import { saShouldUseMockTenants } from './mvp-config.jsx';
// Mock data — Super Admin Tezus (gestão de tenants da plataforma)
// 50 lojas brasileiras · 2 planos (basic e pro) · MRR ~ R$ 15k

function buildMockTenantDomain(subdomain) {
  // Template comes from Super Admin config when available (set by configService at runtime).
  const cached = typeof window !== 'undefined' ? window.__SA_CACHED_CONFIG__ : null;
  const template = cached?.tenant_domain_template || '{subdomain}.localhost';
  return String(template).replace('{subdomain}', subdomain);
}
const STORE_COLORS = [
  '#1B3D60', '#5b8cc9', '#2e7d7d', '#c77d2e', '#8458b3',
  '#2b8a5b', '#b85450', '#3b6fa8', '#7a5230', '#6b4c7c',
];

// ── Planos do backend atual ──────────────────────────────────────────────────
// Apenas basic e pro são aplicáveis a tenants reais.
// Enterprise: rascunho / em breve — NÃO pode ser aplicado a tenant via formulário.
export let PLANS = [
  { id: 'basic', name: 'Basic', price: 199, pageviews: 50000,  users: 10 },
  { id: 'pro',   name: 'Pro',   price: 499, pageviews: 200000, users: 30 },
];
// Enterprise: somente referência — não selecionável em formulários
const ENTERPRISE_PLAN = { id: 'enterprise', name: 'Enterprise', price: null, pageviews: null, users: null, draft: true };

const STATUSES = {
  ativo:        { label: 'Ativo',        variant: 'success' },
  trial:        { label: 'Trial',        variant: 'info'    },
  inadimplente: { label: 'Inadimplente', variant: 'danger'  },
  suspenso:     { label: 'Suspenso',     variant: 'neutral' },
};

// Lojas brasileiras realistas (50 tenants da plataforma)
const STORE_NAMES = [
  { name: 'Petiskaria do Chef',    dom: 'petiskaria-do-chef' },
  { name: 'Moda Lis Atacado',      dom: 'modalis'           },
  { name: 'Bodega 73',             dom: 'bodega73'          },
  { name: 'Outlet Calçado Fácil',  dom: 'calcadofacil'      },
  { name: 'Dona Clara Doces',      dom: 'donaclara'         },
  { name: 'Terra Nova Cosméticos', dom: 'terranova'         },
  { name: 'Ferragens Pampulha',    dom: 'pampulha'          },
  { name: 'Ateliê Nina',           dom: 'atelienina'        },
  { name: 'Oficina do Skate',      dom: 'oficinadoskate'    },
  { name: 'Bike Mania SP',         dom: 'bikemaniasp'       },
  { name: 'Verde Vivo Plantas',    dom: 'verdevivo'         },
  { name: 'Papelaria Rabisco',     dom: 'rabisco'           },
  { name: 'Cervejaria Lúpulo',     dom: 'lupulocervejas'    },
  { name: 'Loja do Churrasco',     dom: 'lojadochurrasco'   },
  { name: 'Ortopedia Recife',      dom: 'ortopediarecife'   },
  { name: 'Kids Baby Store',       dom: 'kidsbaby'          },
  { name: 'Xará Eletrônicos',      dom: 'xaraeletronicos'   },
  { name: 'Casa & Cia Utilidades', dom: 'casaecia'          },
  { name: 'Meu Vinil',             dom: 'meuvinil'          },
  { name: 'Vila Verde Móveis',     dom: 'vilaverdemoveis'   },
  { name: 'Tech Quest Games',      dom: 'techquest'         },
  { name: 'Pets Felizes',          dom: 'petsfelizes'       },
  { name: 'Natureba Orgânicos',    dom: 'natureba'          },
  { name: 'Sapataria Dom Luiz',    dom: 'domluiz'           },
  { name: 'Brinquedoteca RJ',      dom: 'brinquedotecarj'   },
  { name: 'Café Três Corações',    dom: 'cafe3coracoes'     },
  { name: 'Jardim das Sementes',   dom: 'jardimdassementes' },
  { name: 'Sobrado Decor',         dom: 'sobradodecor'      },
  { name: 'Garagem do Som',        dom: 'garagemdosom'      },
  { name: 'Estúdio Papel Crepe',   dom: 'papelcrepe'        },
  { name: 'Marcenaria Bauru',      dom: 'marcenariabauru'   },
  { name: 'Arte & Cia Artesanato', dom: 'arteecia'          },
  { name: 'Doce Dia Confeitaria',  dom: 'docedia'           },
  { name: 'Mundo Geek Store',      dom: 'mundogeek'         },
  { name: 'Boutique Lívia',        dom: 'boutiquelivia'     },
  { name: 'Pesca & Aventura',      dom: 'pescaaventura'     },
  { name: 'Farmácia Dr. Jorge',    dom: 'drjorge'           },
  { name: 'Surf Shop Itacaré',     dom: 'surfitacare'       },
  { name: 'Vinho & Afins',         dom: 'vinhoeafins'       },
  { name: 'Relojoaria Tempo',      dom: 'relojoariatempo'   },
  { name: 'Esporte Total',         dom: 'esportetotal'      },
  { name: 'Livraria Quintal',      dom: 'livrariaquintal'   },
  { name: 'Aromaterapia Zen',      dom: 'aromazen'          },
  { name: 'Bazar Popular',         dom: 'bazarpopular'      },
  { name: 'Tecidos Gabriela',      dom: 'tecidosgabriela'   },
  { name: 'Pizzaria Home Kits',    dom: 'pizzakits'         },
  { name: 'Ótica Nova Visão',      dom: 'novavisao'         },
  { name: 'Cosméticos Juá',        dom: 'juabeleza'         },
  { name: 'Luna Perfumes',         dom: 'lunaperfumes'      },
  { name: 'EcoHouse Reciclados',   dom: 'ecohouse'          },
];

const OWNER_NAMES = [
  'Renata Souza', 'Felipe Andrade', 'Camila Rocha', 'Bruno Alves', 'Patrícia Costa',
  'Eduardo Barbosa', 'Mariana Castro', 'Rafael Teixeira', 'Letícia Nunes', 'Diego Moraes',
  'Vanessa Pinto', 'Márcio Freitas', 'Luciana Dias', 'Rodrigo Monteiro', 'Cristina Azevedo',
];

const CITIES = [
  { c: 'São Paulo', s: 'SP' }, { c: 'Rio de Janeiro', s: 'RJ' }, { c: 'Belo Horizonte', s: 'MG' },
  { c: 'Curitiba',  s: 'PR' }, { c: 'Porto Alegre',   s: 'RS' }, { c: 'Salvador',       s: 'BA' },
  { c: 'Fortaleza', s: 'CE' }, { c: 'Recife',         s: 'PE' }, { c: 'Manaus',         s: 'AM' },
  { c: 'Goiânia',   s: 'GO' }, { c: 'Florianópolis',  s: 'SC' }, { c: 'Vitória',        s: 'ES' },
];

function seeded(i) {
  let x = Math.sin(i * 97.3) * 10000;
  return x - Math.floor(x);
}
function makeDate(daysAgo) {
  const d = new Date(2026, 3, 19); // 19 de abril de 2026
  d.setDate(d.getDate() - daysAgo);
  return d;
}
function addDays(d, days) {
  const r = new Date(d);
  r.setDate(r.getDate() + days);
  return r;
}
function fmtDate(d) {
  if (!(d instanceof Date)) return String(d || '—');
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }).replace('.', '');
}
function daysBetween(a, b) {
  return Math.round((b - a) / (1000 * 60 * 60 * 24));
}

// Gera 50 lojas tenants — usando apenas basic e pro
export let STORES = STORE_NAMES.map((s, i) => {
  const r  = seeded(i);
  const r2 = seeded(i + 100);
  const r3 = seeded(i + 200);

  // Distribuição: 34 ativo, 8 trial, 5 inadimplente, 3 suspenso = 50
  let status;
  if      (i < 34) status = 'ativo';
  else if (i < 42) status = 'trial';
  else if (i < 47) status = 'inadimplente';
  else             status = 'suspenso';

  // Apenas basic (idx 0) ou pro (idx 1)
  const planIdx     = Math.floor(r * 2);
  const plan        = PLANS[planIdx];
  const createdDays = Math.floor(r2 * 520) + (status === 'trial' ? 0 : 30);
  const createdAt   = makeDate(createdDays);

  let nextDueOffset;
  if      (status === 'trial')        nextDueOffset =  Math.floor(r3 * 12) + 1;
  else if (status === 'inadimplente') nextDueOffset = -Math.floor(r3 * 14) - 2;
  else if (status === 'suspenso')     nextDueOffset = -Math.floor(r3 * 45) - 20;
  else                                nextDueOffset =  Math.floor(r3 * 28) + 2;
  const nextDue = addDays(makeDate(0), nextDueOffset);

  const city = CITIES[i % CITIES.length];
  const ownerName = OWNER_NAMES[i % OWNER_NAMES.length];
  const firstName = ownerName.split(' ')[0].toLowerCase();

  return {
    id:           `stor_${String(i + 1).padStart(4, '0')}`,
    name:         s.name,
    domain:       buildMockTenantDomain(s.dom),
    customDomain: i % 5 === 0 ? `${s.dom.replace(/-/g, '')}.com.br` : null,
    plan,
    status,
    createdAt,
    nextDue,
    color:        STORE_COLORS[i % STORE_COLORS.length],
    mrr:          (status === 'suspenso' || status === 'trial') ? 0 : plan.price,
    ownerName,
    ownerEmail:   `${firstName}@${s.dom.replace(/-/g, '')}.com.br`,
    ownerPhone:   `(${11 + (i % 80)}) 9${String(8000 + i).slice(-4)}-${String(1000 + i * 17).slice(-4)}`,
    city:         city.c,
    state:        city.s,
    cnpj:         `${10 + i}.${String(100 + i * 3).padStart(3, '0')}.${String(200 + i * 7).padStart(3, '0')}/0001-${String(10 + i).padStart(2, '0')}`,
    usage: {
      pageviews: Math.floor(plan.pageviews * (0.2 + r  * 0.75)),
      users:     Math.min(plan.users, Math.floor(1 + r3 * plan.users)),
    },
  };
});

const TOTAL_MRR = STORES.reduce((a, b) => a + b.mrr, 0);

// Gráfico de crescimento — últimos 6 meses
const GROWTH = [
  { month: 'Nov/25', stores: 22, mrr:  6300 },
  { month: 'Dez/25', stores: 28, mrr:  8100 },
  { month: 'Jan/26', stores: 33, mrr:  9700 },
  { month: 'Fev/26', stores: 39, mrr: 11500 },
  { month: 'Mar/26', stores: 45, mrr: 13200 },
  { month: 'Abr/26', stores: STORES.length, mrr: TOTAL_MRR },
];

// Alertas derivados em tempo real
const ALERTS = [
  ...STORES.filter(s => s.status === 'inadimplente').slice(0, 3).map(s => ({
    type: 'danger', icon: 'overdue',
    title: `${s.name} está com pagamento atrasado há ${Math.abs(daysBetween(s.nextDue, makeDate(0)))} dias`,
    meta: `Plano ${s.plan.name} · R$ ${s.plan.price.toFixed(2).replace('.', ',')}`,
    storeId: s.id,
  })),
  ...STORES.filter(s => s.status === 'trial' && daysBetween(makeDate(0), s.nextDue) <= 5).slice(0, 2).map(s => ({
    type: 'warning', icon: 'trial',
    title: `${s.name} termina o trial em ${daysBetween(makeDate(0), s.nextDue)} dias`,
    meta: 'Sem método de pagamento cadastrado',
    storeId: s.id,
  })),
  ...STORES.filter(s => s.status === 'suspenso').slice(0, 1).map(s => ({
    type: 'info', icon: 'suspended',
    title: `${s.name} foi suspensa`,
    meta: 'Suspensa · motivo: inadimplência',
    storeId: s.id,
  })),
];

const KPIS = {
  total:         STORES.length,
  ativas:        STORES.filter(s => s.status === 'ativo').length,
  trial:         STORES.filter(s => s.status === 'trial').length,
  inadimplentes: STORES.filter(s => s.status === 'inadimplente').length,
  mrr:           TOTAL_MRR,
};

// Acessos recentes (página de detalhe da loja)
const RECENT_ACCESS = [
  { user: 'Renata Souza',  email: 'renata@donaclara.com.br',   role: 'Proprietária',   when: 'Há 2 horas',     ip: '177.142.12.8' },
  { user: 'Felipe Andrade', email: 'felipe@donaclara.com.br',   role: 'Gerente',        when: 'Ontem, 18:32',   ip: '177.142.12.8' },
  { user: 'Renata Souza',  email: 'renata@donaclara.com.br',   role: 'Proprietária',   when: '17 Abr, 09:15',  ip: '179.215.88.12' },
  { user: 'Ana Vargas',    email: 'ana@tezus.com',             role: 'Suporte Tezus',  when: '15 Abr, 14:22',  ip: '200.1.10.44'   },
];

// Timeline da loja
const TIMELINE = [
  { when: 'Há 2 horas', event: 'Acesso da proprietária',                      by: 'Renata Souza',              kind: 'active' },
  { when: 'Ontem',      event: 'Pagamento recebido — R$ 499,00',              by: 'Stripe · Visa •••• 4242',   kind: 'active' },
  { when: '12 Abr',     event: 'Plano alterado de Basic para Pro',            by: 'Renata Souza',              kind: 'active' },
  { when: '05 Abr',     event: 'Loja publicada no domínio personalizado',     by: 'sistema',                   kind: 'active' },
  { when: '02 Mar',     event: 'Conta criada',                                by: 'cadastro@donaclara.com.br', kind: 'active' },
];

// Usuários internos da Tezus
const INTERNAL_USERS = [
  { name: 'Julio Lazzaron', email: 'julio@tezus.com',    role: 'Super admin', status: 'ativo',   last: 'Agora'      },
  { name: 'Pedro Chaves',   email: 'pedro@tezus.com',    role: 'Admin',       status: 'ativo',   last: 'Há 10 min'  },
  { name: 'Beatriz Lima',   email: 'beatriz@tezus.com',  role: 'Suporte',     status: 'ativo',   last: 'Há 2 horas' },
  { name: 'Rafael Tavares', email: 'rafael@tezus.com',   role: 'Suporte',     status: 'ativo',   last: 'Ontem'      },
  { name: 'Carolina Dias',  email: 'carolina@tezus.com', role: 'Admin',       status: 'inativo', last: 'Há 22 dias' },
];

// Log de auditoria
const AUDIT = [
  { user: 'Ana Vargas',     action: 'Suspendeu loja',               storeName: 'Garagem do Som',        when: 'Hoje, 14:22',   kind: 'danger'  },
  { user: 'Pedro Chaves',   action: 'Login como lojista',           storeName: 'Dona Clara Doces',      when: 'Hoje, 11:08',   kind: 'info'    },
  { user: 'Beatriz Lima',   action: 'Alterou plano para Pro',       storeName: 'Moda Lis Atacado',      when: 'Hoje, 09:47',   kind: 'info'    },
  { user: 'Pedro Chaves',   action: 'Criou usuário interno',         storeName: '—',                     when: 'Ontem, 16:12',  kind: 'neutral' },
  { user: 'Ana Vargas',     action: 'Ativou loja',                   storeName: 'Outlet Calçado Fácil',  when: 'Ontem, 14:55',  kind: 'info'    },
  { user: 'Rafael Tavares', action: 'Login como lojista',           storeName: 'Oficina do Skate',      when: 'Ontem, 10:30',  kind: 'info'    },
  { user: 'Ana Vargas',     action: 'Alterou configurações globais',storeName: '—',                     when: '17 Abr, 15:41', kind: 'neutral' },
  { user: 'Beatriz Lima',   action: 'Reenviou cobrança',             storeName: 'Ferragens Pampulha',    when: '17 Abr, 09:22', kind: 'neutral' },
];

const _useMockStores = saShouldUseMockTenants();
if (!_useMockStores) {
  STORES = [];
}

export function setPLANS(next) {
  PLANS = next;
}

export function setSTORES(next) {
  STORES = next;
}


export {
  ALERTS,
  AUDIT,
  CITIES,
  ENTERPRISE_PLAN,
  GROWTH,
  INTERNAL_USERS,
  KPIS,
  OWNER_NAMES,
  RECENT_ACCESS,
  STATUSES,
  STORE_COLORS,
  TIMELINE,
  addDays,
  buildMockTenantDomain,
  daysBetween,
  fmtDate,
  makeDate,
  seeded,
};
